import { Component, OnInit, Input, OnChanges, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';
import { UntypedFormControl } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { createCustomInputControlValueAccessor, ValueAccessorComponent } from '../base/Input.component';



@Component({
  selector: 'app-mat-select-filtered',
  templateUrl: './mat-select-filtered.component.html',
  styleUrls: ['./mat-select-filtered.component.scss'],
  providers: [createCustomInputControlValueAccessor(MatSelectFilteredComponent)
  ],
})
export class MatSelectFilteredComponent<T> extends ValueAccessorComponent<string>
  implements OnInit, AfterViewInit, OnChanges {

  constructor(protected cdr: ChangeDetectorRef) {
    super();
  }

  itemsFiltered: ReplaySubject<T[]> = new ReplaySubject<T[]>(1);
  filter: UntypedFormControl = new UntypedFormControl();
  select: UntypedFormControl = new UntypedFormControl();
  _onDestroy = new Subject<void>();

  @Input() loading: boolean = false;
  @Input() name: string = "";
  @Input() items: T[];
  @Input() valueColumn: string = "";
  @Input() descriptionColumns: string[];

  @Input() disabled: boolean;
  @Input() dataSize: number;
  @Input() required: boolean;
  @Input() tabIndex: number;
  @Input() emptyOption: false;
  @Input() separator = ' ';
  @Input() placeHolder = '';
  @Input() multiple: boolean = false;


  ngOnChanges(inputs) {
    this.cdr.detectChanges();

    //this.itemsFiltered = new ReplaySubject<T[]>(1);

    if (inputs.items) {
      if (this.items) {
        this.itemsFiltered.next(this.items.slice());
      }
    }
  }

  ngAfterViewInit(): void {
    if (this.required) {
      this.markAsTouchedAndDirty();
    }
  }

  ngOnInit() {
    this.inicializarSelect();
  }

  setDisabledState?(isDisabled: boolean): void { }

  getDescription(item): string {
    let description = '';
    const errorDescription = 'No se ha podido obtener la descripción';

    if (this.descriptionColumns.length === 1) {
      description = this.getEntityDescription(item, this.descriptionColumns[0]);
      return description === '' ? errorDescription : description;
    }

    this.descriptionColumns.forEach(element => {
      const text = this.getEntityDescription(item, element);
      if (text) {
        if (description === '') {
          description = text;
        } else {
          description = `${description}${this.separator}${text}`;
        }
      }
    });

    return description === '' ? errorDescription : description;
  }

  getEntityDescription(item, descriptionColumn: string) {
    let description = '';
    const column = descriptionColumn.split(".");

    if (this.hasProperty(item, column[0])) {
      if (column.length > 1)
        description = item[column[0]][column[1]].toString().trim();
      else
        description = item[column[0]].toString().trim();
    }

    return description;
  }

  onModelChanged(event) {
    this.value = event;
  }

  inicializarSelect() {
    this.filter.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {
      this.filtrar();
    });
  }

  clear() {
    this.value = undefined;
  }

  private filtrar() {
    if (!this.items) {
      return;
    }
    // obtenemos la clave a buscar
    let search = this.filter.value;
    if (!search) {
      this.itemsFiltered.next(this.items.slice());
      return;
    } else {
      search = search.trim().toLowerCase();
    }
    // filtramos
    this.itemsFiltered.next(
      this.items.filter(item => {
        return (
          this.getDescription(item)
            .trim()
            .toLowerCase()
            .indexOf(search) > -1
        );
      })
    );
  }

  hasProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  }

  clearSelectedValue(event) {
    this.value = undefined;
    this.innerValue = undefined;
    event.stopPropagation();
  }

  public markAsTouchedAndDirty() {
    this.select.markAsDirty();
    this.select.markAsTouched();
  }
}
